export default "__VITE_ASSET__a7e6514c__"